export default __webpack_public_path__ + "static/media/debate_13.9204b4ca.JPG";